import {
  Alert,
  App,
  Button,
  Checkbox,
  Input,
  Modal,
  notification,
  Radio,
  Space,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import routes from "../../../engine/routes";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import { mainTypesPrestation } from "../../../utils/typesPrestation";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  daysJsFormat,
  modeInterpretariat,
  renderUserName,
  roles,
  statusPrestationsValues,
  subStatus,
  typeIntervention,
} from "../../../utils/constants";
import { createPortal } from "react-dom";

import { FcCancel } from "react-icons/fc";
import { defaultProps, modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  followPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { AiFillCalendar } from "react-icons/ai";
import { FiCheckCircle } from "react-icons/fi";
import {
  initDateEndPrestation,
  initDateStartPrestation,
  initendDate,
  initstartDate,
} from "../../../pages/Prestations/Slices/Prestation.default.state";
import { BiLinkExternal } from "react-icons/bi";
import { FaCheckDouble } from "react-icons/fa";
import { DurationHourChecker } from "../../../pages/Prestations/PrestationDetail/DurationHourChecker";
import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../CustomForm/form.helpers";

export const PrestationFollow = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loading } = useSelector(state => state.prestation);
  const { status } = prestation;
  const { user } = useContext(UserContext);

  const isInterprete = userHasLevel({ only: { [roles.interprete]: "r" } });

  const inputs = inputsFollow({ prestation, isInterprete, user });

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();
  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationFollow);
  };
  const onSubmitForm = async data => {
    const startDate = dayjs(data.intervention.startDate);
    const diff = startDate.diff(dayjs(), "hour");

    if (isInterprete) {
      if (diff <= 24) {
        return notification.error({
          message:
            "Désolé, il n’est pas possible de créer un suivi ayant lieu dans moins de 24h. Merci de contacter la permanence par téléphone afin de créer ce suivi.",
        });
      }

      if (dayjs().diff(dayjs(prestation.finalStartDate), "hour") >= 48) {
        return notification.error({
          message:
            "Désolé, il n’est pas possible de créer un suivi basé sur une prestation ayant eu lieu il y a plus de 48h. Merci de contacter la permanence par téléphone afin de créer ce suivi.",
        });
      }
    }

    await dispatch(
      followPrestation({ followedPrestation: prestation._id, ...data }),
    );
    close();
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationFollow,
    containerStyle: { minWidth: "600px" },
    title: "Voulez-vous créer une prestation de suivie ?",
    open: open,
    cancelText: "Fermer",
    okText: "Confirmer",
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <Alert
          message={`Attention `}
          description={
            <>
              Merci de ne créer un suivi que si la prestation concerne{" "}
              <b>
                le même Demandeur, le même Bénéficiaire et le même Lieu
                d'intervention.
              </b>{" "}
              Dans le cas contraire, merci de contacter la permanence.
            </>
          }
          type="warning"
          showIcon
          closable={true}
        />
        <br />
        <p>Spécifier la date et l’heure de la prestation de suivi.</p>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        Confirmer et créer le suivi
      </Button>,
    ],
  };

  if (
    status === statusPrestationsValues.draft ||
    status === statusPrestationsValues.waiting
  ) {
    return null;
  }

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsFollow = ({ prestation, user, isInterprete }) => {
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    tags,
    interventionLocation,
  } = prestation;
  const { id } = useParams();
  let initStart = initDateStartPrestation();
  let initEnd = initDateEndPrestation();
  if (isInterprete) {
    initStart = dayjs()
      .add(1, "days")
      .format();
    initEnd = dayjs()
      .add(1, "days")
      .format();
  }

  const disabledDate = current => {
    if (onlyRoleMapping([roles.institution, roles.interprete])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          required: true,
          disabledDate,
          label: "Date et heure de début",
          name: "intervention.startDate",
          value: dayjs(initStart),
          suffixIcon: <AiFillCalendar />,
          onChange: e => {},
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  false,
                );
              },
            }),
          ],
          // showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          // disabledDate: current => {
          //   // Disable dates that are less than 24 hours from now
          //   return current && current < dayjs().add(1, "days");
          // },
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                let newStartD = end.subtract(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.startDate": newStartD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date-time",
          col: 12,
        },
        {
          required: true,
          disabledDate,
          label: "Date et heure de fin",
          name: "intervention.endDate",
          value: dayjs(initEnd),
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  false,
                );
              },
            }),
          ],
          suffixIcon: <AiFillCalendar />,
          watch: "intervention.startDate",
          onChange: e => {},
          watchRenderCondition: false,
          // disabledDate: current => {
          //   // Disable dates that are less than 24 hours from now
          //   return (
          //     current &&
          //     current <
          //       dayjs()
          //         .add(1, "h")
          //         .add(1, "days")
          //   );
          // },
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          noWrapper: true,
          name: "durationHour",
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={["intervention.startDate", "intervention.endDate"]}
              isLongDuration={false}
            />
          ),
        },
        {
          label: "Lieu de l'intervention (Institution)",
          placeholder: "Modification d’intervenant sur place, de salle, …",
          required: true,
          value: prestation.intervention.locationName,
          name: "intervention.locationName",
          disabled: !userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "input",
          col: 24,
        },
        {
          required: true,
          visible: prestation.intervention.type === typeIntervention.in_person,
          label: "Adresse d'intervention",
          name: "intervention.location",
          value: prestation.intervention.location,
          type: "google-adress",
          disabled: !userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: "Numéro de téléphone pour l'intervention",
          name: "intervention.phone",
          type: "input",
          required: true,
          value: prestation.intervention.phone,
          visible: prestation.intervention.type === typeIntervention.phone,
          addonBefore: "+41",
          col: 24,
        },
        {
          label: "Lien pour la visio-conférence",
          name: "intervention.linkVisio",
          type: "input",
          required: true,
          value: prestation.intervention.linkVisio,
          visible: prestation.intervention.type === typeIntervention.visio,
          addonBefore: <BiLinkExternal />,
          col: 24,
        },
      ],
    },
  ];
};
